/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import  {hideMessage} from '../../../_actions/message.actions';
import Svg from '../Svg/Svg';

class MessageArea extends Component {
    static get propTypes() {
        return {
            messages: PropTypes.object,
            hideAlertBox: PropTypes.func
        };
    }
    constructor(props) {
        super(props);
        this.state = {
            showAlert: false
        };
        this.Timer = [];

    }
    componentWillReceiveProps(nextProps){
        if (nextProps.messages.show) {
            clearTimeout(this.Timer);
            this.Timer = setTimeout(() => {
                this.props.hideAlertBox();
            }, 4000);
        }

        //this.setState({showAlert: nextProps.messages.show ? nextProps.messages.show : false});
        nextProps.messages.show ?this.setState({showAlert: true}) : setTimeout(()=>{this.setState({showAlert: false});},500);

    }

    closeAlert = () => {
        this.props.hideAlertBox();
    };

    render() {
        const {messages} = this.props;
        const showHideClass = this.props.messages.show ? 'show' : 'hide';
        return (
            <div className='message_wrapper pe-row'>
                {(!messages.firstLoad && this.state.showAlert) && <div className={`message_box ${showHideClass} ${messages.type.styleClass}`}>
                    <div className='close_btn' onClick={this.closeAlert}><span><Svg svgString='remove-sm-24'/></span></div>
                    <div className='message_body'>
                        {messages.type.icon && <div className='message_icon'>
                            <Svg svgString={messages.type.icon}/>
                        </div>}
                        <div className='message_content'>
                            <p>{messages.message}</p>
                        </div>
                    </div>
                </div>}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        messages: state.messages
    };
}

const mapDispatchToProps = dispatch => {
    return {
        hideAlertBox : () => {
            dispatch(hideMessage());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MessageArea);


// WEBPACK FOOTER //
// ./src/components/widgets/MessageBox/MessageArea.js